import { Component } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { CheckStepsDialogComponent } from '../check-steps-dialog/check-steps-dialog.component';
import { Router } from '@angular/router';

@Component({
  selector: 'app-lead-progress-bar',
  templateUrl: './lead-progress-bar.component.html',
  standalone: false,
})
export class LeadProgressBarComponent {
  currentStepIdx: number = 4;

  constructor(
    public checkStepsDialog: MatDialog,
    public router: Router,
  ) {}

  ngOnInit() {
    let oSteps = document.getElementById('steps');
    if (oSteps) {
      let x =
        oSteps.children[oSteps.children.length - 1].getBoundingClientRect()
          .left -
        oSteps.getBoundingClientRect().left +
        150;
      oSteps.style.width = x + 'px';
    }
  }

  public selectStep(stpIdx: number) {
    this.currentStepIdx = stpIdx;
    this._selectStep();
  }

  reopenStep_click(idx: number) {
    this.currentStepIdx = idx;
    this._selectStep();
  }

  scrollLeft() {
    let oSteps = document.getElementById('steps');
    let oContainer = document.getElementById('stepsContainer');

    if (oSteps && oContainer) {
      // stop scrolling if the left-most child is fully in view
      if (
        oSteps.children[0].getBoundingClientRect().left >=
        oContainer.getBoundingClientRect().left
      ) {
        return;
      }

      if (oSteps.style.marginLeft == '') {
        oSteps.style.marginLeft = '0px';
      }
      oSteps.style.marginLeft =
        parseInt(oSteps.style.marginLeft.replace('px', '')) + 100 + 'px';
    }
  }

  scrollRight() {
    let oContainer = document.getElementById('stepsContainer');
    let oSteps = document.getElementById('steps');

    if (oSteps && oContainer) {
      // stop scrolling if the right-most child is fully in view
      if (
        oSteps.children[oSteps.children.length - 1].getBoundingClientRect()
          .right <= oContainer?.getBoundingClientRect().right
      ) {
        return;
      }

      if (oSteps.style.marginLeft == '') {
        oSteps.style.marginLeft = '0px';
      }
      oSteps.style.marginLeft =
        parseInt(oSteps.style.marginLeft.replace('px', '')) - 100 + 'px';
    }
  }

  viewStep_click(idx: number) {
    let ref = this.checkStepsDialog.open(CheckStepsDialogComponent, {
      width: '500px',
      disableClose: false,
      data: {
        leadId: '',
        stepIdx: idx,
      },
    });

    this.router.events.subscribe(() => {
      ref.close();
    });

    ref.afterClosed().subscribe((isComplete) => {
      if (isComplete && idx == this.currentStepIdx) {
        let oSteps = document.getElementById('steps');
        if (oSteps) {
          oSteps.children[this.currentStepIdx].classList.add('selected');
          oSteps.children[this.currentStepIdx].classList.add('complete');
        }

        ++this.currentStepIdx;
        //this._selectStep();
      }
    });
  }

  _selectStep() {
    let oSteps = document.getElementById('steps');

    if (oSteps) {
      for (var i = 0; i < oSteps.children.length; i++) {
        oSteps.children[i].classList.remove('selected');
        oSteps.children[i].classList.remove('complete');
        if (i < this.currentStepIdx) {
          oSteps.children[i].classList.add('complete');
        } else if (i == this.currentStepIdx) {
          oSteps.children[i].classList.add('selected');
        }
      }

      let x =
        oSteps.children[this.currentStepIdx].getBoundingClientRect().left -
        oSteps.getBoundingClientRect().left;

      if (x > 300) {
        let oContainer = document.getElementById('stepsContainer');

        if (oContainer) {
          oContainer.scrollLeft = x - 225;
        }
      }
    }
  }
}
